export default "__VITE_ASSET__4NhIhthD__"